import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_txn_hdr_RowClass} from '../../../dbschema';

export class InventoryTransactionHdrContainerModel extends BaseContainerModel {
  bl_inv_txn_hdr: bl_inv_txn_hdr_RowClass = new bl_inv_txn_hdr_RowClass();
}




